<template>
  <b-modal
      v-bind="$props"
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
  >
    <div class="text-center py-2">
      <div class="d-flex justify-content-center mb-3">
        <img :src="DuplicateIcon" alt="Duplicate Icon" width="40" height="40" />
      </div>
      <h4>{{ $t('purchase_plans.modal_messages.confirm_duplicate_title') }}</h4>
      <p class="m-0 text-muted">{{ $t('purchase_plans.modal_messages.confirm_duplicate_description') }}</p>
    </div>
    <template #modal-footer>
      <div class="d-flex justify-content-end gap-2 w-100">
        <b-button
            :disabled="loading"
            block
            variant="light"
            @click="handleCancel"
        >
          <b>{{ $t('Cancel') }}</b>
        </b-button>
        <b-button
            :disabled="loading"
            block
            class="m-0"
            variant="primary"
            @click="handleConfirm"
        >
          <b-spinner v-if="loading" class="me-2" small></b-spinner>
          <b>{{ lodash.startCase($t('purchase_plans.buttons.continue_duplicate')) }}</b>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ConfirmationModal from '@/components/modals/confirmation-modal.vue'
import DuplicateIcon from '@/assets/icons/DuplicateIcon.svg'

const PREFILL_FIELDS = [
  'product_id',
  'sales_plan_id',
  'submitted_at',
  'payment_type',
  'partner_id',
  'processing_id',
  'estimated_size_start',
  'estimated_size_end',
  'estimated_quantity',
  'estimated_amount',
  'estimated_margin',
  'supervisor_id',
  'product_type',
]

export default {
  name: 'purchase-plan-duplicate-confirmation',
  extends: ConfirmationModal,
  props: {
    id: {default: 'purchase-plan-duplicate-confirmation-modal'},
    hideHeader: {default: true},
    title: {default: ''},
  },
  data() {
    return {
      DuplicateIcon,
      loading: false,
      targetModel: null,
    };
  },
  methods: {
    show(model) {
      this.targetModel = model ?? null
      this.$bvModal.show(this.id)
    },
    handleCancel() {
      this.hide()
    },
    handleConfirm() {
      const targetModel = this.targetModel || {}

      const prefill = PREFILL_FIELDS.reduce((acc, field) => {
        const value = targetModel[field]
        if (value !== null && value !== undefined && value !== '') {
          acc[field] = value
        }
        return acc
      }, {})

      this.hide()

      return this.$router.push({name: 'purchase_plans.create', params: {prefill}})
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .modal-footer {
    border: none;
  }
}
</style>
